'use client';

import React from 'react';

import { MainHero, Heading } from '@ui';
import {
  heroLine,
  readHeroMetaItems,
  readHeroMetaLabel,
  type LayoutLocale,
} from '@lib/heroLocale';

interface DesignSystemHeroProps {
  sectionID?: string;
  classes?: string;
  isSpanish?: boolean;
}

const DesignSystemHero: React.FC<DesignSystemHeroProps> = ({
  sectionID = 'design-system-hero',
  classes = 'design-system-hero',
  isSpanish = false,
}) => {
  const locale: LayoutLocale = isSpanish ? 'es' : 'en';
  const ns = 'design-system';

  const title =
    heroLine('hero_title', ns, locale) ?? (locale === 'es' ? 'Sistema de diseño' : 'Design system');
  const metaLabel = readHeroMetaLabel(ns, locale, locale === 'es' ? 'Rasgos del sistema' : 'System traits');
  const metaItems = readHeroMetaItems(ns, locale);

  return (
    <MainHero
      id={sectionID}
      className={classes && classes.trim() ? classes.trim() : undefined}
      main={
        <>
          <Heading
            as='h1'
            eyebrow={heroLine('hero_eyebrow', ns, locale)}
            title={title}
            description={heroLine('hero_description', ns, locale)}
            descriptionClassName='hero-sub'
            subtitle={heroLine('hero_subtitle', ns, locale)}
          />
          {metaItems.length > 0 ? (
            <ul className='meta' aria-label={metaLabel}>
              {metaItems.map((label) => (
                <li key={label}>{label}</li>
              ))}
            </ul>
          ) : null}
        </>
      }
    />
  );
};

export default DesignSystemHero;
